import React from "react";
import { RCCButton,  RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import HeaderDashboard from "src/components/DashboardComponents/DefaultDashboardComponents/HeaderDashboard";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { GroupersOccurrence } from "src/pages/Occurrences/Panel/interface";
import { ICardConfigs, MAX_HEIGHT_LISTS_DASHBOARD } from "../../../interface";
import { IDashboardOccurrencesData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";

const DashboardListsOccurrencesSector: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();

	const { data, loading } = useEffectFetchData<IDashboardOccurrencesData[]> (
		"DashboardOccurrences/ListSector"
	);

	const dataCard = data && data.length > 0 ? data : [{
		id:0,
		title: translate("Sem setor"),
		notStarted:0,
		opened:0,
		finished:0, 
		canceled:0,
		disaproved:0,
		late:0
	}] as IDashboardOccurrencesData[];

	return(
		<>
			<DefaultContainer>
				<HeaderDashboard 
					description={card?.daa002Descricao}
					title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo Ocorrências por Setor")}
					hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
					isLoading={loading}
				>
					<Link to={`/occurrences/panel/?group=${GroupersOccurrence.SECTOR}`} >	
						<RCCTooltip
							text={translate("Painel de Ocorrências")}
							color="grey"
						>
							<RCCButton
								color="transparent"
							>
								<AppIcons 
									name="occurrences"
									size={14}
								/>
							</RCCButton>
						</RCCTooltip>
					</Link>
				</HeaderDashboard>
				<DefaultBody maxHeight={MAX_HEIGHT_LISTS_DASHBOARD}>

					<Styles.LiTitles>
						<div />
						<div><RCCTooltip text={translate("Não iniciadas")} position="leftEnd" color="blue" >{translate("Não iniciadas")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Em andamento")}  position="leftEnd" color="purple" >{translate("Em andamento")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Atrasadas")}  position="leftEnd" color="red" >{translate("Atrasadas")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Concluídas")}  position="leftEnd" color="green" >{translate("Concluídas")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Canceladas")}  position="leftEnd" color="grey" >{translate("Canceladas")} </RCCTooltip></div>
						<div><RCCTooltip text={translate("Reprovadas")}  position="leftEnd" color="black" >{translate("Reprovadas")} </RCCTooltip></div>
					</Styles.LiTitles>		
								
					{dataCard && dataCard.map((item) => (
						<Styles.LiPanelBodyContent  key={item.id}>
							<Li data={item} />
						</Styles.LiPanelBodyContent>
					))}
						
				</DefaultBody>
			</DefaultContainer>
		</>
	);
};

export default DashboardListsOccurrencesSector;
